import React from 'react';
import { Box, Tooltip } from '@mui/material';

/** Annotation stays out of table sizing and never replaces the cell value. */
export default function TableValidationFlag({ message }: { message: string }) {
  return <Tooltip title={message} arrow describeChild>
    <Box component="button" type="button"
      aria-label={`Review: ${message}`}
      onClick={event => event.stopPropagation()}
      sx={{ position: 'absolute', right: 1, top: 1, p: 0, width: 14, height: 14,
        border: 0, borderRadius: '50%', bgcolor: '#8f1d1d', color: '#fff',
        fontSize: 10, lineHeight: '14px', cursor: 'help', zIndex: 1,
        '&:focus-visible': { outline: '2px solid #1565c0', outlineOffset: 1 } }}>!</Box>
  </Tooltip>;
}
